angular.module('eatself')
.filter('trpn', function() {
  return function(str) {
	return str;
  };
})